<div class="col-12 col-lg-6 pt-2">
  <!--create data view-->
  @if (!selectedHandOverLogData && !selectedHandOverLogId) {
    @if (currentStep == 1) {
      <div class="row row-cols-2 mb-5">
        <div class="col">
          <button
            class="btn btn-lg w-100"
            [ngClass]="
              selectedPatrolEventIds?.length || selectedNonPatrolEvents?.length
                ? 'btn-outline-primary'
                : 'btn-secondary'
            "
            (click)="sendLater()"
          >
            {{
              selectedPatrolEventIds?.length || selectedNonPatrolEvents?.length
                ? "Send Later"
                : "Cancel (Delete Draft)"
            }}
          </button>
        </div>
        <div class="col">
          <button
            type="button"
            [disabled]="!selectedRecipients?.length"
            class="btn btn-lg w-100"
            [ngClass]="
              alreadySentPatrolEventIds?.length || patrolEventDataList?.length
                ? 'btn-primary'
                : 'btn-primary'
            "
            (click)="
              alreadySentPatrolEventIds?.length || patrolEventDataList?.length
                ? (currentStep = 2)
                : (currentStep = 3)
            "
          >
            {{
              alreadySentPatrolEventIds?.length || patrolEventDataList?.length
                ? "Next"
                : "Next"
            }}
          </button>
        </div>
      </div>
      <div class="col mb-4">
        <textarea
          class="form-control"
          placeholder="Subject (Summary)"
          cols="20"
          rows="1"
          wrap="hard"
          maxlength="900"
          type="text"
          [(ngModel)]="handOverLogDescription"
          id="holDescriptionField"
          autofocus
        ></textarea>
      </div>
      <div class="mb-2 fw-semibold">Select Recipient(s):</div>
      @if (recipientList?.length > 10 || handOverLogRecipientsNextCursor) {
        <div class="mb-1">
          <gtapp-auto-complete
            [data]="recipientSearchList"
            placeHolder="Guard Name"
            searchKeyword="full_name"
            [itemTemplate]="assigneeListTemplate"
            (inputChanged)="searchAssignee($event)"
            (selected)="addSelectedAssignee($event)"
          >
          </gtapp-auto-complete>
        </div>
      }
      <ng-template #assigneeListTemplate let-item>
        <div>
          {{ item?.full_name }}
        </div>
      </ng-template>
      <div class="overflow-assignee" id="assigneeList">
        <table class="table my-2">
          <tbody>
            @for (assignee of recipientList; track assignee) {
              <tr class="cursor-pointer" (click)="addRemovessignee(assignee)">
                <td class="py-4">
                  <div class="d-flex">
                    <div>
                      <div class="form-floating">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [checked]="assignee?.selected"
                        />
                      </div>
                    </div>
                    <div class="flex-grow-1 ms-2">
                      {{ assignee?.full_name }}
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      @if (handOverLogRecipientsNextCursor) {
        <div class="mt-3">
          <button
            type="button"
            class="btn btn-secondary btn-lg"
            (click)="getRecipients()"
          >
            Load More
          </button>
        </div>
      }
    }
    @if (currentStep == 2) {
      <div class="row row-cols-2 g-2 mb-4">
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-secondary w-100"
            (click)="currentStep = 1"
          >
            Back
          </button>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-primary w-100"
            (click)="currentStep = 3; formatCompleteList()"
          >
            Next
          </button>
        </div>
      </div>
      @if (alreadySentPatrolEventIds?.length) {
        <div class="text-end">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm mb-2"
            (click)="alreadySentPatrolEventIds = []; getPatrolEvents()"
          >
            Show All Patrol Updates
          </button>
        </div>
      }
      <div class="overflow-65vh mb-4">
        <div class="row row-cols-1 p-2 g-2">
          @for (event of patrolEventDataList; track event) {
            <div class="col">
              <div
                (click)="selectUnselectEvents(event)"
                class="cursor-pointer hover bg-secondary-subtle clearfix border rounded p-2 h-100 py-3 text-dark"
              >
                @if (event?.file_url) {
                  <div class="float-end">
                    <ng-template
                      *ngTemplateOutlet="
                        filePreviewTemplate;
                        context: { value: event }
                      "
                    ></ng-template>
                  </div>
                }
                <div class="d-inline">
                  <div class="d-flex gap-2 mb-3">
                    <div>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        [checked]="selectedPatrolEventIds?.includes(event?.id)"
                      />
                    </div>
                    <div class="flex-grow-1 d-flex gap-2">
                      <div class="me-3 small">
                        <div>
                          {{ event?.updated_at | customDate: "d MMM y HH:mm" }}
                        </div>

                        <div class="text-secondary">
                          {{
                            event?.file_url
                              ? [".mp4", ".mov", ".webm", ".mkv"].includes(
                                  event?.file_extension
                                )
                                ? "[Video]"
                                : "[Photo]"
                              : "[Comment]"
                          }}
                        </div>
                      </div>
                      <div class="small">
                        <div>
                          {{ event?.site_name }}
                        </div>
                        <div class="text-secondary">
                          {{ event?.company_name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                @if (event?.detail) {
                  <div class="gt-multi-line mb-2">
                    {{ event?.detail }}
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>

      <div>
        <gtapp-pagination-control
          [pageSize]="patrolEventRows"
          [pageNum]="patrolEventPageNum"
          [previous]="patrolEventPrevious"
          [totalRows]="patrolEventTotalCount"
          (onClickPagination)="onChangePatrolEventPagination($event)"
          (onChangePagination)="onChangePatrolEventPagination($event)"
        >
        </gtapp-pagination-control>
      </div>
    }
    @if (currentStep == 3) {
      <div class="row row-cols-2 mb-3">
        <div class="col">
          <button
            class="btn btn-lg btn-secondary w-100"
            (click)="
              alreadySentPatrolEventIds?.length || patrolEventDataList?.length
                ? (currentStep = 2)
                : (currentStep = 1)
            "
          >
            Back
          </button>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-success w-100"
            [disabled]="handOverLogCreated || !selectedEvents?.length"
            (click)="createhandOverLog()"
          >
            Send
          </button>
        </div>
      </div>
      <div class="row row-cols-2 mt-3 mb-4">
        <div class="col">
          <button
            class="btn btn-outline-primary btn-lg w-100"
            (click)="addEditComment(commentRef)"
          >
            + Add Text
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-outline-primary btn-lg w-100"
            (click)="openCamPopup()"
          >
            + Attach Photo
          </button>
        </div>
      </div>
      <!-- RECIPIENTS -->
      <div class="d-flex flex-wrap column-gap-4 row-gap-2 p-2">
        <dl>
          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              <dt>Recipient(s)</dt>
            </div>
          </div>
          <dd>
            @for (
              assignee of selectedRecipients;
              track assignee;
              let l = $last
            ) {
              <span> {{ assignee?.full_name }}{{ l ? "" : ", " }}</span>
            }
          </dd>
        </dl>
        @if (handOverLogDescription) {
          <dl>
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <dt>Subject (Summary)</dt>
              </div>
            </div>
            <dd class="gt-multi-line fw-semibold">
              {{ handOverLogDescription }}
            </dd>
          </dl>
        }
      </div>

      <!-- LOG ENTRIES -->
      <div class="overflow-65vh mb-4">
        <div class="row row-cols-1 p-2 g-2">
          @for (event of selectedEvents; track event; let i = $index) {
            <div class="col">
              <div
                class="cursor-pointer hover bg-secondary-subtle clearfix border rounded p-2 h-100 py-3 text-dark"
              >
                @if (event?.file_url) {
                  <div class="float-end">
                    <ng-template
                      *ngTemplateOutlet="
                        filePreviewTemplate;
                        context: { value: event }
                      "
                    ></ng-template>
                  </div>
                }

                <div class="d-inline">
                  <div class="d-flex gap-2 mb-3">
                    @if (selectedEvents?.length > 1) {
                      <div class="order-input-width">
                        <dt>Order</dt>
                        <input
                          type="tel"
                          inputmode="numeric"
                          pattern="[0-9]*"
                          class="form-control"
                          list="numbers"
                          [min]="1"
                          [max]="selectedEvents?.length"
                          [value]="i + 1"
                          (change)="onPositionChange(i, $event)"
                        />
                        <datalist id="numbers">
                          @for (
                            number of selectedEventsDataIndexList;
                            track number
                          ) {
                            <option [value]="number">
                              {{ number }}
                            </option>
                          }
                        </datalist>
                      </div>
                    }
                    <div class="flex-grow-1 d-flex gap-2">
                      <div class="me-3 small">
                        <div>
                          {{ event?.updated_at | customDate: "d MMM y HH:mm" }}
                        </div>

                        <div class="text-secondary">
                          {{
                            event?.file_url
                              ? [".mp4", ".mov", ".webm", ".mkv"].includes(
                                  event?.file_extension
                                )
                                ? "[Video]"
                                : "[Photo]"
                              : "[Comment]"
                          }}
                        </div>
                      </div>
                      <div class="small">
                        <div>
                          {{ event?.site_name }}
                        </div>
                        <div class="text-secondary">
                          {{ event?.company_name }}
                        </div>
                      </div>
                    </div>

                    @if (!event?.company_name) {
                      <div class="d-flex gap-2 flex-wrap">
                        <button
                          class="btn btn-sm btn-outline-secondary flex-grow-1"
                          (click)="addEditComment(commentRef, event)"
                        >
                          Edit
                        </button>
                        <button
                          class="btn btn-sm btn-outline-danger flex-grow-1"
                          (click)="deleteNonPatrolEvent(event)"
                        >
                          Delete
                        </button>
                      </div>
                    }
                  </div>
                </div>

                @if (event?.detail) {
                  <div class="gt-multi-line mb-2">
                    {{ event?.detail }}
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
  }
  <!--detailed data view-->
  @if (selectedHandOverLogData && selectedHandOverLogId) {
    <div class="mt-3">
      <div class="d-flex flex-wrap column-gap-4 row-gap-2 p-2">
        <dl>
          <dt>From</dt>
          <dd>{{ selectedHandOverLogData?.created_by?.full_name }}</dd>
        </dl>
        @if (isAdmin) {
          <dl>
            <dt>Recipient</dt>
            <dd>{{ selectedHandOverLogData?.received_by?.full_name }}</dd>
          </dl>
        }
        <dl>
          <dt>Date</dt>
          <dd>
            {{
              selectedHandOverLogData?.updated_at | customDate: "d MMM y HH:mm"
            }}
          </dd>
        </dl>
        @if (selectedHandOverLogData?.description) {
          <dl>
            <dt>Subject (Summary)</dt>
            <dd class="gt-multi-line fw-semibold">
              {{ selectedHandOverLogData?.description }}
            </dd>
          </dl>
        }
      </div>
      <dl class="pt-3">
        <dd>
          <ng-template
            *ngTemplateOutlet="
              holEventDetailTableRef;
              context: { value: selectedHandOverLogData?.events }
            "
          ></ng-template>
        </dd>
      </dl>
    </div>
  }
</div>
<ng-template #commentRef let-commentRef="dialogRef" let-data>
  <div class="card dialog-box">
    <div class="card-header">
      {{ data?.detail ? "Edit Text" : "Add Text" }}
      <span class="float-end" (click)="commentRef.close(); newComment = ''">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="form-group input-group">
        <textarea
          class="form-control"
          rows="5"
          wrap="hard"
          placeholder="Enter comment here"
          autofocus
          [(ngModel)]="newComment"
          id="updateCommentBox"
        ></textarea>
        @if (newComment) {
          <span
            class="input-group-text"
            (click)="clearAndFocusTextBox('updateCommentBox')"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>
      <div class="row row-cols-2 mt-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-dark btn-lg w-100"
            (click)="commentRef.close(); newComment = ''"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-primary btn-lg w-100"
            [disabled]="!newComment || previousComment === newComment"
            (click)="commentRef.close(data?.id ? data : true)"
          >
            {{ data?.detail ? "Update" : "Add" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #holEventDetailTableRef let-dataItem="value">
  <div class="overflow-65vh mb-4">
    <div class="row row-cols-1 p-2 g-2"></div>
    @for (event of dataItem; track event) {
      <div class="col mb-2">
        <div
          class="bg-secondary-subtle clearfix border rounded p-2 h-100 py-3 text-dark"
        >
          @if (event?.file_url) {
            <div class="float-end">
              <ng-template
                *ngTemplateOutlet="
                  filePreviewTemplate;
                  context: { value: event }
                "
              ></ng-template>
            </div>
          }
          <div class="d-inline">
            <div class="d-flex gap-2 mb-3">
              <div class="me-3 small">
                <div>
                  {{ event?.updated_datetime | customDate: "d MMM y HH:mm" }}
                </div>

                <div class="text-secondary">
                  {{
                    event?.file_url
                      ? [".mp4", ".mov", ".webm", ".mkv"].includes(
                          event?.file_extension
                        )
                        ? "[Video]"
                        : "[Photo]"
                      : "[Comment]"
                  }}
                </div>
              </div>
              <div class="small">
                <div>
                  {{ event?.site_name }}
                </div>
                <div class="text-secondary">
                  {{ event?.company_name }}
                </div>
              </div>
            </div>
          </div>

          @if (event?.detail) {
            <div class="gt-multi-line mb-2">
              {{ event?.detail }}
            </div>
          }
        </div>
      </div>
    }
  </div>
</ng-template>

<ng-template #filePreviewTemplate let-update="value" let-inBrowser="inBrowser">
  <div class="media-view mb-2" (click)="$event.stopImmediatePropagation()">
    <!-- @if (largeView) { -->
    @if ([".mp4", ".mov", ".webm", ".mkv"].includes(update?.file_extension)) {
      <video controls muted class="media-file">
        <source [src]="update?.file_url" />
        Your browser does not support the video tag.
      </video>
    } @else if ([".mp3"].includes(update?.file_extension)) {
      <audio
        [src]="update?.file_url"
        controls
        controlslist="play timeline volume nofullscreen nodownload noremoteplayback noplaybackrate"
      ></audio>
    } @else {
      <img
        (click)="onOpenFile(update)"
        [src]="update?.file_url"
        class="media-file"
      />
    }
    <!-- } @else {
      <div (click)="onOpenFile(update); $event.stopImmediatePropagation()">
        @if (
          [".mp4", ".mov", ".webm", ".mkv"].includes(update?.file_extension)
        ) {
          <span>
            <i class="fa-solid fa-file-video fa-2x text-primary"></i>
          </span>
        } @else {
          <span>
            <i class="fa-solid fa-image fa-2x text-primary"></i>
          </span>
        }
      </div>
    } -->
  </div>
</ng-template>
